import { replaceDynamicPaths } from 'lib/routes/replace-dynamic-paths'

const root = '/'

export const websitePaths = {
  root,
  homepage: root,

  terms: `${root}terms`,
  privacy: `${root}privacy`,
  fairUse: `${root}fair-use`,

  login: `${root}sign-in`,
  loginWithEmail: `${root}sign-in/email`,
  register: `${root}sign-up`,
  registerWithEmail: `${root}sign-up/email`,

  authCallback: `${root}auth/callback`,
  authCallbackMagicLink: `${root}auth/callback-magic-link`,
  authCli: `${root}auth/cli`,

  careers: `${root}careers`,
  career: `${root}careers/[slug]`,

  docs: `${root}docs`,
  docsPage: `${root}docs/[...slug]`,

  blog: `${root}blog`,
  blogPage: `${root}blog/[...slug]`,
  blogCategory: `${root}blog/category/[category]`,

  guides: `${root}guides`,
  guidesPage: `${root}guides/[...slug]`,

  changelog: `${root}changelog`,
  changelogPage: `${root}changelog/[...slug]`,

  community: `${root}community`,

  new: `${root}new/[account]`,
  newImport: `${root}new/[account]/import`,
  newTemplate: `${root}new/[account]/template`,

  newOrganization: `${root}new-organization`,

  templates: `${root}templates`,

  frameworks: `${root}frameworks`,
  framework: `${root}frameworks/[framework]`,

  examples: `${root}examples`,

  pricing: `${root}pricing`,

  dashboard: `${root}dashboard`,

  security: `${root}security`,

  settings: `${root}settings`,

  roadmap: `${root}roadmap`,

  about: `${root}about`,

  // Features pages
  cli: `${root}cli`,
  auth: `${root}auth`,
  edgeGateway: `${root}edge-gateway`,
  branching: `${root}branching`,
  analytics: `${root}analytics`,
  edgeCaching: `${root}edge-caching`,

  // Alternatives
  appSync: `${root}alternatives/appsync`,
  hasura: `${root}alternatives/hasura`,
  apolloServer: `${root}alternatives/apollo-server`,
  graphqlYoga: `${root}alternatives/graphql-yoga`,

  // Use cases
  commerce: `${root}use-cases/commerce`,
  mobile: `${root}use-cases/mobile`,
  web3: `${root}use-cases/web3`,
  ai: `${root}use-cases/ai`
}

export const getWebsiteNewPath = (accountSlug?: string) => {
  if (accountSlug) {
    return replaceDynamicPaths(websitePaths.new, accountSlug)
  }

  return websitePaths.new.replace('/[account]', '')
}

export const getWebsiteNewConfigurePath = (
  accountSlug?: string,
  isTemplate?: boolean
) => {
  const basePath = isTemplate
    ? websitePaths.newTemplate
    : websitePaths.newImport

  if (accountSlug) {
    return replaceDynamicPaths(basePath, accountSlug)
  }

  return basePath.replace('/[account]', '')
}
